export default "__VITE_ASSET__DyGS8Sap__"